import loadable from '@loadable/component';


const ReviewsFormLazy = loadable(() => import('./ReviewsForm'));

export default ReviewsFormLazy;
